import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../assets/8insights-logo.svg";

/* ──────────────────────────────────────────────────────────────
   Pages that should ALWAYS use the solid navy header
   (no transparent state at the top). Edit this list freely.
   ────────────────────────────────────────────────────────────── */
const ALWAYS_SOLID_ROUTES = [
  // Auth pages
  "/login",
  "/forgot-password",
  "/reset-password",
  "/check-user-type",
  // Legal pages
  "/privacy-policy",
  "/terms-of-use",
  "/cookie-policy",
  "/disclaimer",
  // Contact / Join Us
  "/contact",
  "/join-us",
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Force solid on the configured routes (regardless of scroll position)
  const forceSolid =
    ALWAYS_SOLID_ROUTES.includes(location.pathname) ||
    location.pathname.startsWith("/learn");

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isOpen]);

  // Close the mobile menu with the Escape key (a11y)
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen]);

  const toggleNavbar = () => {
    setIsOpen((prev) => !prev);
  };

  const closeNavbar = () => {
    setIsOpen(false);
  };

  return (
    <nav
      className={`navbar navbar-expand-md navbar-light fixed-top ${
        isScrolled || isOpen || forceSolid ? "solid-navbar" : "transparent-navbar"
      }`}
    >
      <div className="container navbar-container">
        <Link className="navbar-brand" to="/" onClick={closeNavbar}>
          <img src={logo} alt="8 Insights Logo" className="navbar-logo" />
        </Link>

        <button
          className={`navbar-toggler ${isOpen ? "open" : ""}`}
          type="button"
          onClick={toggleNavbar}
          aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
        >
          <span className="toggler-icon">{isOpen ? "✕" : "☰"}</span>
        </button>
      </div>

      <div
        id="primary-navigation"
        className={`navbar-collapse ${isOpen ? "open" : ""}`}
        role="dialog"
        aria-modal={isOpen ? "true" : undefined}
        aria-label="Site navigation"
      >
        {/* <ul className="navbar-nav">
          <li className="nav-item">
            <Link className="nav-link" to="/" onClick={closeNavbar}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about" onClick={closeNavbar}>
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/what-we-do" onClick={closeNavbar}>
              What We Do
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/join-us" onClick={closeNavbar}>
              Join Us
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/contact" onClick={closeNavbar}>
              Contact
            </Link>
          </li>
        </ul> */}

        <ul className="navbar-nav">
            <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={closeNavbar} end>
                Home
                <i className="bi bi-chevron-right nav-arrow" aria-hidden="true" />
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/about" onClick={closeNavbar}>
                About Us
                <i className="bi bi-chevron-right nav-arrow" aria-hidden="true" />
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/what-we-do" onClick={closeNavbar}>
                What We Do
                <i className="bi bi-chevron-right nav-arrow" aria-hidden="true" />
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/join-us" onClick={closeNavbar}>
                Join Us
                <i className="bi bi-chevron-right nav-arrow" aria-hidden="true" />
                </NavLink>
            </li>

            <li className="nav-item">
                <NavLink className="nav-link" to="/contact" onClick={closeNavbar}>
                Contact
                <i className="bi bi-chevron-right nav-arrow" aria-hidden="true" />
                </NavLink>
            </li>

            <li className="nav-item nav-login">
                <NavLink className="nav-link login-btn" to="/login" onClick={closeNavbar}>
                    Login <i className="bi bi-box-arrow-in-right"></i>
                </NavLink>
            </li>


        </ul>

        {/* Mobile-only: Follow us + Find us on (Evolve Journey app) */}
        <div className="nav-social">
          <p className="nav-social-label">Follow us</p>
          <a
            href="https://www.linkedin.com/company/8-insights/"
            target="_blank"
            rel="noreferrer"
            className="nav-social-icon"
            aria-label="8 Insights on LinkedIn"
            onClick={closeNavbar}
          >
            <i className="bi bi-linkedin" />
          </a>

          <p className="nav-social-label">Find us on</p>
          <div className="nav-app-badges">
            {/* TODO: replace href="#" with the Evolve Journey App Store URL */}
            <a href="#" target="_blank" rel="noreferrer" aria-label="Download Evolve Journey on the App Store">
              <img className="nav-badge-apple" src="/badges/app-store-badge.svg" alt="Download on the App Store" />
            </a>
            {/* TODO: replace href="#" with the Evolve Journey Google Play URL */}
            <a href="#" target="_blank" rel="noreferrer" aria-label="Get Evolve Journey on Google Play">
              <img className="nav-badge-google" src="/badges/google-play-badge.png" alt="Get it on Google Play" />
            </a>
          </div>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;